import Vue from 'vue'
import Vuex from 'vuex'
// import user from './user'
// import tour from './tour'
import createPersistedState from 'vuex-persistedstate'
import swal from 'sweetalert2'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    referrer: '',
    user: {},
    member: {},
    adminLang: 'tw',
    showLang: false,
    ipIsAdmin: false,
    jwt: '', // 改?
    group: ''
  },
  getters: {
    // emailVerify (state) {
    //   return state.member.email_verified_at.length > 0
    // },
    // 登入身分
    loginRole (state) {
      let role = ''
      if (state.jwt.length) {
        if (state.group === '') {
          role = 'member' // 一般會員
        } else if (state.group === 'agent') {
          role = 'agent' // 代理
        } else { role = 'staff' } // 內部人員(包含user跟admin)
      }
      return role
    }
  },
  mutations: {
    // 記推薦碼
    setReferrer (state, token) {
      state.referrer = token
    },
    switchAdminLang (state, x) {
      state.adminLang = x
    },
    ipIsAdmin (state, val) {
      state.ipIsAdmin = val
    },
    login (state, data) {
      state.jwt = data.jwt
      // 如果是工作人員，data.user 會有group_name，則記錄
      // 否則就是一般會員，帶入會員資料
      if (data.user && data.user.group_name) {
        state.group = data.user.group_name
        state.user = data.user
      } else state.member = data.member
      // console.log(state)
    },
    // checkJWT (state, data) {
    // },
    logout (state, to) {
      state.user = {}
      state.jwt = ''
      state.group = ''
      state.member = {}
      swal.fire({
        icon: 'success',
        text: '已登出',
        showConfirmButton: false,
        timer: 1000
      })
      if (to) {
        router.push(to)
      } else {
        if (router.history.current.path !== '/') {
          router.go(0)
        }
      }
    }
  },
  actions: {
  },
  // 把vuex的資料存在localstorage
  plugins: [createPersistedState({
    key: 'tstar',
    paths: ['referrer', 'adminLang', 'showLang', 'jwt', 'group', 'member', 'user']
  })]
})
